module.exports = __webpack_public_path__ + "static/009-e6598fb782fd0fbb1fe12fbf1ab7de12.jpg";